import { render, staticRenderFns } from "./clinician_dashboard_list.vue?vue&type=template&id=ea987c48&scoped=true"
import script from "./clinician_dashboard_list.vue?vue&type=script&lang=js"
export * from "./clinician_dashboard_list.vue?vue&type=script&lang=js"
import style0 from "./clinician_dashboard_list.vue?vue&type=style&index=0&id=ea987c48&prod&scoped=true&lang=css"
import style1 from "./clinician_dashboard_list.vue?vue&type=style&index=1&id=ea987c48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea987c48",
  null
  
)

export default component.exports